import script from "./SidenavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavItem.vue?vue&type=script&setup=true&lang=js"

import "./SidenavItem.vue?vue&type=style&index=0&id=2a2b38ee&lang=scss"

const __exports__ = script;

export default __exports__